<h1 mat-dialog-title *ngIf="data.title" [innerHtml]="data.title"></h1>
<div mat-dialog-content>
  <p [innerHtml]="data.text"></p>
  <mat-form-field class="ok-cancel-dialog--description" *ngIf="data.inputTitle">
    <textarea matInput rows="3" [placeholder]="data.inputTitle" [formControl]="description" cdkFocusInitial></textarea>
    <mat-error *ngIf="description.hasError('required')">
      This field is required
    </mat-error>
  </mat-form-field>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onNoClick()">Cancel</button>
  <button mat-raised-button [mat-dialog-close]="getValue()" [color]="'accent'" cdkFocusInitial
    [disabled]="data.inputTitle && data.inputRequired && !description.valid">{{data.okText}}</button>
</div>
